// extracted by mini-css-extract-plugin
module.exports = {"Container":"VideoSection_Container__2tqT5","Video":"VideoSection_Video__10JB7","Iframe":"VideoSection_Iframe__31dEw"};